import { Stack, Typography } from '@mui/material'

import {
  ConsolePreSalesAggregationDetailFragment,
  Maybe,
} from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { TicketPurchaseStatus } from './TicketPurchaseStatus'
import { TicketStatusTableCell } from './TicketStatusTableCell'
import { TicketUsageStatus } from './TicketUsageStatus'

type TicketStatusCellProps = {
  preSalesAggregation: Maybe<ConsolePreSalesAggregationDetailFragment>
  updatedAt?: string
  showEmptyState?: boolean
}
export const TicketStatusCell: Cell<TicketStatusCellProps> = ({
  preSalesAggregation,
  updatedAt,
  showEmptyState,
}) => {
  const { t } = useTranslation('consoleEventDetail')

  return (
    <CellFrame pt={1} sx={{ pb: 5 }}>
      <Typography variant="h4" lineHeight="28px">
        {t('ticketStatus', 'チケット状況')}
      </Typography>
      {!!updatedAt && (
        <Stack>
          <Typography
            variant="caption"
            color="text.secondary"
            width="100%"
            align="right"
          >
            {t('ticketStatusUpdatedAt', { date: updatedAt })}
          </Typography>
        </Stack>
      )}
      {(!!preSalesAggregation?.preSaleItems?.length || showEmptyState) && (
        <>
          <Stack py={3} direction="row" spacing={3}>
            <TicketPurchaseStatus
              {...preSalesAggregation?.aggregation?.purchases}
            />
            <TicketUsageStatus
              {...preSalesAggregation?.aggregation?.ticketUsage}
              {...preSalesAggregation?.aggregation?.purchases}
            />
          </Stack>
          <Stack pt={3}>
            <TicketStatusTableCell
              preSaleItems={preSalesAggregation?.preSaleItems}
            />
          </Stack>
        </>
      )}
      {!preSalesAggregation?.preSaleItems?.length && !showEmptyState && (
        <Stack py={6}>
          <Typography variant="body1" color="text.secondary" align="center">
            {t('emptyTicketMessage', 'チケット状況はありません')}
          </Typography>
        </Stack>
      )}
    </CellFrame>
  )
}
